import Popup from '@/shared/components/layers/Popup/Popup'
import React from 'react'

import otherCss from '../CompanyCard/CompanyCard.module.css'
import { Input } from '@/shared/components/common/Input/Input'

type CompanyCardPopupProps = {
  title: string
  open: boolean
  onClose: () => void

  isPeriod: boolean
  setIsPeriod: (p: boolean) => void
}

const CompanyCardPopup: React.FC<CompanyCardPopupProps> = ({
  title,
  open,
  onClose,
  isPeriod,
  setIsPeriod
}) => {
  return (
    <Popup 
      open={open}
      onClose={onClose} 
      title={title}
      size='xl' 
      fullHeight
    >
      <div className={otherCss.settings}>
          <Input
            type='checkbox'
            checked={!isPeriod}
            label='За все время'
            onChange={e => setIsPeriod && setIsPeriod(e.target.checked)}
          />
      </div>
    </Popup>

  )
}

export default CompanyCardPopup